/**
 * 監聽跨分頁的登入/登出事件，把自己同步成對應狀態
 *
 * - 收到 'logout' → 用 eraseOnly 清空，不打 signout API（已由發起分頁打過）
 * - 收到 'login' → 若本分頁尚未載入 member，跑 useMemberAsync()
 *   （此時 cookie 已被發起分頁寫入，本分頁的 useCookie ref 還沒同步，
 *    所以 useMemberAsync 內部會以 authorization 為依據去打 /me）
 */
import { listenSessionEvent } from '@/composables/member/useSessionBroadcast'

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  listenSessionEvent(async (event) => {
    if (event === 'logout') {
      await useLogout({ eraseOnly: true })
      return
    }
    if (event === 'login') {
      const authorization = useAuthorization()
      const member = useMember()
      // useCookie 不會自動 reactive 到其他分頁寫入的 cookie，所以強制重讀 document.cookie
      const cookieMatch = typeof document !== 'undefined'
        ? document.cookie.split('; ').find(row => row.startsWith('ug_authorization='))
        : undefined
      if (cookieMatch) {
        const token = decodeURIComponent(cookieMatch.split('=')[1] ?? '')
        if (token && authorization.value !== token) {
          authorization.value = token
        }
      }
      if (authorization.value && !member.value) {
        useMemberAsync()
      }
    }
  })
})
